<style lang="scss"></style>

<template>
  <div id="modal-cidade" class="modal modal-max-poli fade" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <form @submit.prevent="salvar">
          <div class="modal-header">
            <h4 class="modal-title">{{ id > 0 ? 'ALTERAR' : 'CADASTRAR' }} CIDADE</h4>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-12">
                <div class="card card-block shadow0 m0 pb0">
                  <div class="row form-group">
                    <div class="form-group m0 col-md-8" :class="{ 'has-error': $v.nome.$error }">
                      <label class="control-label">Nome</label>
                      <input
                        type="text"
                        class="form-control underlined"
                        v-model.trim="$v.nome.$model"
                      />
                      <template v-if="$v.nome.$dirty">
                        <span
                          v-if="!$v.nome.required"
                          class="has-error lblerror lblerror"
                        >Campo obrigatório</span>
                      </template>
                    </div>

                    <div
                      class="form-group m0 col-md-4"
                      :class="{ 'has-error': $v.estadoId.$error }"
                    >
                      <label class="control-label">UF</label>
                      <select class="c-select form-control underlined" v-model="$v.estadoId.$model">
                        <option value>Selecione um Estado</option>
                        <option
                          v-for="estado in estados"
                          :key="estado.id"
                          :value="estado.id"
                        >{{ estado.nome }}</option>
                      </select>
                      <template v-if="$v.estadoId.$dirty">
                        <span
                          v-if="!$v.estadoId.required"
                          class="has-error lblerror"
                        >Campo obrigatório</span>
                      </template>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="submit"
              class="btn btn-primary"
              :disabled="enviando"
            >{{ enviando ? "SALVANDO..." : "SALVAR" }}</button>
            <button type="button" class="btn btn-secondary" data-dismiss="modal">CANCELAR</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import { showLoading, closeLoading } from '../../../helpers';
import EstadoService from '../../../services/EstadoService';
import CidadeService from '../../../services/CidadeService';

export default {
  name: 'modal-cidade',
  data() {
    return {
      enviando: false,
      estados: [],
      id: 0,
      nome: '',
      estadoId: '',
    };
  },
  validations: {
    nome: {
      required,
    },
    estadoId: {
      required,
    },
  },
  mounted() {
    // eslint-disable-next-line
    $('#modal-cidade').on('hidden.bs.modal', () => {
      this.clear();
      this.$parent.cidadeId = null;
    });

    if (this.$parent.cidadeId === null) return;

    this.load();
  },
  methods: {
    clear() {
      this.enviando = false;
      this.id = 0;
      this.nome = '';
      this.uf = '';
    },
    async load() {
      try {
        showLoading();

        if (this.estados.length <= 0) {
          this.estados = await EstadoService.findAll();
        }

        if (this.$parent.cidadeId === 0) return;

        const cidade = await CidadeService.findById(this.$parent.cidadeId);

        this.id = cidade.id;
        this.nome = cidade.nome;
        this.estadoId = cidade.estado.id;
      } catch (error) {
        this.$eventBus.$emit('notificationError', error);
      } finally {
        closeLoading();

        // eslint-disable-next-line
        $('#modal-cidade').modal('show');
      }
    },
    async salvar() {
      this.$v.$touch();

      if (this.$v.$invalid) return;

      try {
        this.enviando = true;

        showLoading();

        const cidade = {
          id: this.id,
          nome: this.nome,
          estadoId: this.estadoId,
        };

        await CidadeService.save(cidade);

        this.$toast.success('Cidade salva com sucesso!');

        this.$emit('reload');

        // eslint-disable-next-line
        $('#modal-cidade').modal('hide');
      } catch (error) {
        this.$eventBus.$emit('notificationError', error);
      } finally {
        closeLoading();

        this.enviando = false;
      }
    },
  },
};
</script>
